// extracted by mini-css-extract-plugin
module.exports = {"featureTitle":"_58428f","featureList":"_3736b4"};